var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '@web/utility';
import { useTranslation } from 'react-i18next';
var CHART_MIN_HEIGHT_PX = 340;
export function WidgetEmptyState(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'chart' : _b, className = _a.className, minHeight = _a.minHeight;
    var t = useTranslation().t;
    var height = minHeight !== null && minHeight !== void 0 ? minHeight : (variant === 'chart' ? CHART_MIN_HEIGHT_PX : undefined);
    return (_jsx("div", __assign({ className: cx('flex w-full items-center justify-center text-sm text-gray-500', className), style: height !== undefined ? { minHeight: height } : undefined }, { children: t('widgetEmptyState.selectedPeriod') })));
}
